import React from "react";
import moment from "moment";

interface Props {
    datetime: string;
};

const MDTimestamp = (props: Props) => {
    const { datetime } = props;
    const [timestamp, refreshTimestamp] = React.useState(moment(new Date(datetime)).fromNow());
    React.useEffect(() => {
        let timeout = null;
        function setTimer(){
            timeout = setTimeout(() => {
                refreshTimestamp(moment(new Date(datetime)).fromNow());
                setTimer();
            }, 10000);
        }
        setTimer();
        return () => {
            if(timeout){
                clearTimeout(timeout);
            }
        }
    });
    return (
        <span style={{fontWeight: "400", fontSize: "12px", marginLeft: "5px"}}>
            {timestamp}
        </span>
    )
};

export default MDTimestamp;